<rask-kontrakt-header [entity]="entity()"></rask-kontrakt-header>

<rask-skogsvard-list></rask-skogsvard-list>

<rask-kontrakt-certifiering [kontrakt]="entity()"></rask-kontrakt-certifiering>

@if (kontrakt.id) {
  <rask-kontrakt-betalning
    *raskPermitted="[{ role: 'RASK.Kopplanera', canView: false }]; merge: true">
  </rask-kontrakt-betalning>
}

<rask-kontrakt-anteckningar
    [readonly]="kontraktReadonly">
</rask-kontrakt-anteckningar>
<rask-kontrakt-utskrift
    *raskPermitted="[{ role: 'RASK.Kopplanera', canView: false }]; merge: true">
</rask-kontrakt-utskrift>
<rask-kontrakt-utskrift-dokument></rask-kontrakt-utskrift-dokument>
<rask-kontrakt-bilagor [kontraktId]="kontrakt.id" [readonly]="kontraktReadonly"></rask-kontrakt-bilagor>

<rask-toggle-panel
  *raskPermitted="digitalSigneringPermissions"
  helpUrl="https://sveaskog.sharepoint.com/:p:/r/sites/Glantan/SiteCollectionDocuments/Virkesk%C3%B6p/Lathund%20Digital%20Signering.pptx?d=wa0ab0cf6ab1941d6af3e4059eea0e935&csf=1&web=1&e=mXddbV"
  label="Digital signering">
  <rask-kontrakt-digitalsignering dokumentTyp="SkogsvardsKontrakt"></rask-kontrakt-digitalsignering>
</rask-toggle-panel>
